//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import template from './bulk-actions-confirmation-modal.html';

import angular from 'angular';

angular.module('curalate').component('bulkActionsConfirmationModal', {
  bindings: {
    confirmationCta: '@',
    confirmationMessage: '@',
    onCancel: '&',
    onComplete: '&',
    requiredPermission: '@',
  },
  template,
});
